module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("It Ain’t Called a Jack-o’-Lantern for Nothing")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("I")]), _vm._v("n September 2002, a forty-five-year-old man in Warren, Michigan, was convicted of indecent exposure and sentenced to ninety days in jail. Police arrested the man after neighbors complained that he was naked in his backyard and was performing indecent acts with a pumpkin. When the man was approached by police he blurted out, “What, is it midnight already?” Sorry, I made up that last part."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("A JOB INTERVIEW IS NOT A DATE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('em', [_c('span', {
    staticClass: "small"
  }, [_vm._v("New York Newsday")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a182744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c14_r1.vue
// module id = 114
// module chunks = 0